// extracted by mini-css-extract-plugin
export default {"crBreadcrumb":"CrBreadcrumb_crBreadcrumb__jYvyd","crumb":"CrBreadcrumb_crumb__IAqoQ","crumbTitle":"CrBreadcrumb_crumbTitle__Q4LKR","crumbDivider":"CrBreadcrumb_crumbDivider__tX4Xv"};